/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

export enum SpecialOfferTypeEnum {
  MAIN_PAGE = "MAIN_PAGE",
  TAB = "TAB",
  HEADER = "HEADER",
  DOCUMENT = "DOCUMENT",
}

/**
 * Параметры публикации в документе
 */
export interface DocumentDisplayV2 {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;
}

/**
 * Расположение иллюстрации в оверлее
 */
export enum ImagePositionEnum {
  UP = "UP",
  DOWN = "DOWN",
}

/**
 * Параметры публикации в ленте
 */
export interface ListDisplayV2 {
  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Текст спецпредложения в ленте */
  text: string;

  /** Цвет текста спецпредложения в ленте */
  textColor: string;

  /** Цвет фона спецпредложения в ленте */
  background: string;
}

/**
 * Параметры публикации для главной страницы
 */
export interface MainPageDisplayV2 {
  /** Параметры публикации в ленте */
  listDisplay: ListDisplayV2;

  /** Параметры публикации в оверлее */
  viewDisplay: ViewDisplaySettingsV2;
}

/**
 * Параметры публикации в шапке раздела меню
 */
export interface MenuHeaderDisplayV2 {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;
}

/**
 * Параметры лендинга спецпредложения
 */
export interface SpecialOfferLandingSettingsV2 {
  /** Заголовок на спецпредложении в лендинге */
  title: string;

  /** Текст на спецпредложении в лендинге */
  text: string;

  /** Цвет текста на спецпредложении в лендинге */
  textColor: string;

  /** Выравнивание текста на спецпредложении в лендинге */
  textAlignment: string;

  /** Цвет фона спецпредложения в лендинге */
  background: string;

  /**
   * id Изображения
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Ссылка для перехода по кнопке на спецпредложении в лендинге */
  buttonLink: string;

  /** Текст кнопки на спецпредложении в лендинге */
  buttonText: string;

  /** Цвет кнопки на спецпредложении в лендинге */
  buttonColor: string;

  /** Цвет текста кнопки на спецпредложении в лендинге */
  buttonTextColor: string;

  /** Цвет текста кнопки на спецпредложении в лендинге */
  infoBlockImages?: string[];

  /**
   * Инфоблок спецпредложения в лендинге (параметры текстовых блоков)
   * @example {}
   */
  infoblock: string;
}

/**
 * Список спецпредложений
 */
export interface SpecialOffersForClientRespListV2 {
  /** Список спецпредложений */
  specialOffersForClientRespList?: SpecialOffersForClientRespV2[];
}

/**
 * Тело ответа параметров публикации спецпредложения
 */
export interface SpecialOffersForClientRespV2 {
  /**
   * Идентификатор спецпредложения
   * @format uuid
   */
  id?: string;

  /** Параметры публикации для главной страницы */
  mainPageDisplay?: MainPageDisplayV2;

  /** Параметры публикации на вкладке списка */
  tabDisplay?: TabDisplayV2;

  /** Параметры публикации в шапке раздела меню */
  menuHeaderDisplay?: MenuHeaderDisplayV2;

  /** Параметры публикации в документе */
  documentDisplay?: DocumentDisplayV2;

  /** Параметры лендинга спецпредложения */
  landingSettings?: SpecialOfferLandingSettingsV2;
}

/**
 * Параметры публикации на вкладке списка
 */
export interface TabDisplayV2 {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;
}

/**
 * Выравнивание текста
 */
export enum TextAlignmentEnum {
  UP = "UP",
  MIDDLE = "MIDDLE",
  DOWN = "DOWN",
}

/**
 * Параметры публикации в оверлее
 */
export interface ViewDisplaySettingsV2 {
  /** Заголовок */
  title: string;

  /** Основной текст */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Выравнивание текста */
  textAlignment: TextAlignmentEnum;

  /** Цвет фона спецпредложения в оверлее */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Расположение иллюстрации в оверлее */
  imagePosition: ImagePositionEnum;

  /** Текст кнопки */
  buttonText: string;

  /** Цвет кнопки */
  buttonColor: string;

  /** Цвет текста кнопки */
  buttonTextColor: string;
}

/**
 * Параметры публикации в документе
 */
export interface DocumentDisplay {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;
}

/**
 * Параметры публикации в ленте
 */
export interface ListDisplay {
  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Текст спецпредложения в ленте */
  text: string;

  /** Цвет текста спецпредложения в ленте */
  textColor: string;

  /** Цвет фона спецпредложения в ленте */
  background: string;
}

/**
 * Параметры публикации для главной страницы
 */
export interface MainPageDisplay {
  /** Параметры публикации в ленте */
  listDisplay: ListDisplay;

  /** Параметры публикации в оверлее */
  viewDisplay: ViewDisplaySettings;
}

/**
 * Параметры публикации в шапке раздела меню
 */
export interface MenuHeaderDisplay {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;
}

/**
 * Параметры лендинга спецпредложения
 */
export interface SpecialOfferLandingSettings {
  /** Заголовок на спецпредложении в лендинге */
  title: string;

  /** Текст на спецпредложении в лендинге */
  text: string;

  /** Цвет текста на спецпредложении в лендинге */
  textColor: string;

  /** Выравнивание текста на спецпредложении в лендинге */
  textAlignment: string;

  /** Цвет фона спецпредложения в лендинге */
  background: string;

  /**
   * id Изображения
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Ссылка для перехода по кнопке на спецпредложении в лендинге */
  buttonLink: string;

  /** Текст кнопки на спецпредложении в лендинге */
  buttonText: string;

  /** Цвет кнопки на спецпредложении в лендинге */
  buttonColor: string;

  /** Цвет текста кнопки на спецпредложении в лендинге */
  buttonTextColor: string;

  /** Цвет текста кнопки на спецпредложении в лендинге */
  infoBlockImages?: string[];

  /**
   * Инфоблок спецпредложения в лендинге (параметры текстовых блоков)
   * @example {}
   */
  infoblock: string;
}

/**
 * Тело ответа параметров публикации спецпредложения
 */
export interface SpecialOffersForClientResp {
  /**
   * Идентификатор спецпредложения
   * @format uuid
   */
  id?: string;

  /** Параметры публикации для главной страницы */
  mainPageDisplay?: MainPageDisplay;

  /** Параметры публикации на вкладке списка */
  tabDisplay?: TabDisplay;

  /** Параметры публикации в шапке раздела меню */
  menuHeaderDisplay?: MenuHeaderDisplay;

  /** Параметры публикации в документе */
  documentDisplay?: DocumentDisplay;

  /** Параметры лендинга спецпредложения */
  landingSettings?: SpecialOfferLandingSettings;
}

/**
 * Список спецпредложений
 */
export interface SpecialOffersForClientRespList {
  /** Список спецпредложений */
  specialOffersForClientRespList?: SpecialOffersForClientResp[];
}

/**
 * Параметры публикации на вкладке списка
 */
export interface TabDisplay {
  /** Текст спецпредложения */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Цвет фона */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;
}

/**
 * Параметры публикации в оверлее
 */
export interface ViewDisplaySettings {
  /** Заголовок */
  title: string;

  /** Основной текст */
  text: string;

  /** Цвет текста */
  textColor: string;

  /** Выравнивание текста */
  textAlignment: TextAlignmentEnum;

  /** Цвет фона спецпредложения в оверлее */
  background: string;

  /**
   * id илюстрации
   * @format uuid
   */
  imageId: string;

  /** Имя файла иллюстрации */
  imageName: string;

  /** Расположение иллюстрации в оверлее */
  imagePosition: ImagePositionEnum;

  /** Текст кнопки */
  buttonText: string;

  /** Цвет кнопки */
  buttonColor: string;

  /** Цвет текста кнопки */
  buttonTextColor: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-special-offers
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-special-offers.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений V2
     * @name MarkAsReadV2
     * @summary Признак просмотренности спец предложения
     * @request POST:/api/special-offers/v2/external/special-offers/mark-as-read
     */
    markAsReadV2: (data: string[], params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/special-offers/v2/external/special-offers/mark-as-read`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений
     * @name MarkAsRead
     * @summary Признак просмотренности спец предложения
     * @request POST:/api/special-offers/v1/external/special-offers/mark-as-read
     */
    markAsRead: (data: string[], params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/special-offers/v1/external/special-offers/mark-as-read`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений V2
     * @name GetSpecialOffersV2
     * @summary Получение клиентом всех спецпредложений для данного места
     * @request GET:/api/special-offers/v2/external/special-offers
     */
    getSpecialOffersV2: (
      query: { name: string; type: SpecialOfferTypeEnum },
      params: RequestParams = {}
    ) =>
      this.request<SpecialOffersForClientRespListV2, GenericError>({
        path: `/api/special-offers/v2/external/special-offers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений V2
     * @name GetImageV2
     * @summary Получение изображения
     * @request GET:/api/special-offers/v2/external/special-offers/image/{id}
     */
    getImageV2: (id: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/special-offers/v2/external/special-offers/image/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений
     * @name GetSpecialOffers
     * @summary Получение клиентом всех спецпредложений для данного места
     * @request GET:/api/special-offers/v1/external/special-offers
     */
    getSpecialOffers: (
      query: { name: string; type: SpecialOfferTypeEnum },
      params: RequestParams = {}
    ) =>
      this.request<SpecialOffersForClientRespList, GenericError>({
        path: `/api/special-offers/v1/external/special-offers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентские ресты спец предложений
     * @name GetImage
     * @summary Получение изображения
     * @request GET:/api/special-offers/v1/external/special-offers/image/{id}
     */
    getImage: (id: string, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/special-offers/v1/external/special-offers/image/${id}`,
        method: "GET",
        ...params,
      }),
  };
}

export const api = new Api();
